export const UPDATE_TABLE_CONFIG_FAILURE = 'UPDATE_TABLE_CONFIG_FAILURE';

export const updateTableConfigFailure = error => ({
    type: UPDATE_TABLE_CONFIG_FAILURE,
    payload: error,
    error: true,
});
